import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import useTranslation from "translations/hooks/useTranslation";
import Text from "./Text";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    height: 280,
  },
  text: {
    textAlign: "center",
    color: "#344450",
    fontSize: 30,
    [theme.breakpoints.down("1100")]: {
      fontSize: 24,
    },
    [theme.breakpoints.down("769")]: {
      fontSize: 22,
    },
    [theme.breakpoints.down("400")]: {
      fontSize: 20,
    },
  },
}));

export default function NoDataAvailable({title}) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <Text text={t(title?title: "noDataAvailable")} sectionTitle bold/>
    </div>
  );
}
